import { defineMobileWindow } from "@app/overlay";
import { formatBusinessDateText } from "@src/components/business-data-display";
import { WsDepotCardMoveContent } from "./components/WsDepotCardMoveContent/WsDepotCardMoveContent";

/**
 * Реестр overlay-окон карточки цеховой номенклатуры.
 */
export const wsDepotCardWindows = {
    move: defineMobileWindow({
        key: "workshop.depotCard.move",
        title: ({ movement, cardNumber }) =>
            `Движение ${formatBusinessDateText(movement.MoveDate)} цех. номенклатура №${cardNumber}`,
        component: WsDepotCardMoveContent,
    }),
};
